module.exports = __webpack_public_path__ + "static/media/GT-Alpina-Bold.a71255df.ttf";